const id_supplychain_do = {
    "": "Barang Masuk (DO)",

    label: {
        from: "Dikirim dari",
    },

    error: {
        create: "Gagal membuat DO",
        edit: "Gagal mengubah DO",
    },

    success: {
        create: "Berhasil membuat DO",
        edit: "Berhasil mengubah DO",
    },
}

export default id_supplychain_do;